
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

import { faStar as faStarEmpty } from '@fortawesome/free-regular-svg-icons';
import { faStar as faStarFull } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'research-grade',
    templateUrl: './research-grade.component.html',
    styleUrls: ['./research-grade.component.scss'],
    imports: [FontAwesomeModule, NgbModule, TranslatePipe]
})
export class ResearchGradeComponent {
    @Input() grade!: number;

    faStarEmpty = faStarEmpty;
    faStarFull = faStarFull;
}
